import { CatActionTypes, All } from '../actions/categoriesActions';

export interface State {
  categories: Array<any> | null;
}

const initialState: State =
{
  categories: null
}

export function categoriesReducer(state = initialState, action: All): State {
  
  switch (action.type) {
    case CatActionTypes.CAT_SUCCESS: {
      return {
        ...state,
        categories: action.payload.categories
      };
    }
    case CatActionTypes.CAT_FAILURE: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
}
